import React, { FC } from 'react'
import { Rating, Stack, Typography } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import { useTranslation } from 'react-i18next'

import { BEIGE_300, BEIGE_600, GRAY_400, GRAY_700, GRAY_900 } from 'constants/styling/theme'

/**
 * Shown instead of the creative list when the client has no favourite creative yet: favourites are saved only
 * when rating a finished order, so it says how to get one. The empty stars are the
 * rating's own, so the client recognises the step.
 */
export const NoFavouriteCreativesHint: FC = () => {
  const { t } = useTranslation(['purchase_flow_revamp', 'star_rating'])

  return (
    <Stack
      gap={0.8}
      data-cy="pf-revamp-no-favourite-creatives"
      sx={{ border: `1px solid ${BEIGE_600}`, borderRadius: '0.8rem', backgroundColor: BEIGE_300, p: 1.6 }}
    >

      <Rating
        value={0}
        readOnly
        size="large"
        aria-hidden
        emptyIcon={<StarIcon fontSize="inherit" sx={{ color: GRAY_400 }} />}
      />

      <Typography variant="text-md" fontWeight={550} color={GRAY_900}>
        {t('purchase_flow_revamp:instructions.ct_booking.no_favourites_title')}
      </Typography>

      <Typography variant="text-sm" fontWeight={350} color={GRAY_700}>
        {t('purchase_flow_revamp:instructions.ct_booking.no_favourites_body', { favoriteLabel: t('star_rating:favorite_label') })}
      </Typography>

    </Stack>
  )
}
